const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(function () {
  const style = document.createElement('style');
  style.textContent = `
    @media screen and (min-width: 990px) {
      .header__inline-menu summary.header__menu-item {
        padding-right: 2.6rem !important;
      }
    }

    .sv-card__img .sv-card__collection-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `;
  document.head.appendChild(style);
})();

(function () {
  const collectionFeeds = {
    fashion: '/collections/all-upcycled-dress/products.json?limit=50',
    skirt: '/collections/bridal-beaded-skirts-and-skirt-fabric/products.json?limit=1',
    scarf: '/collections/scarfs-or-scarves/products.json?limit=1',
  };

  function getProductImage(product) {
    if (!product) return '';
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images[0]) {
      return product.images[0].src || product.images[0];
    }
    return '';
  }

  function findProduct(products, include, exclude) {
    return products.find((product) => {
      const title = product.title.toLowerCase();
      return title.includes(include) && (!exclude || !title.includes(exclude));
    });
  }

  function setCardImage(section, title, product) {
    const titleElement = Array.from(section.querySelectorAll('.sv-card__title')).find(
      (element) => element.textContent.trim() === title,
    );
    const card = titleElement && titleElement.closest('.sv-card');
    const imageContainer = card && card.querySelector('.sv-card__img');
    const imageUrl = getProductImage(product);

    if (!imageContainer || !imageUrl) return;

    const image = document.createElement('img');
    image.className = 'sv-card__collection-image';
    image.src = imageUrl;
    image.alt = title;
    image.loading = 'lazy';
    image.width = 720;
    image.height = 900;
    imageContainer.replaceChildren(image);
  }

  async function loadFashionImages(section) {
    try {
      const [fashionResponse, skirtResponse, scarfResponse] = await Promise.all([
        fetch(collectionFeeds.fashion),
        fetch(collectionFeeds.skirt),
        fetch(collectionFeeds.scarf),
      ]);

      if (!fashionResponse.ok) return;

      const fashionData = await fashionResponse.json();
      const skirtData = skirtResponse.ok ? await skirtResponse.json() : { products: [] };
      const scarfData = scarfResponse.ok ? await scarfResponse.json() : { products: [] };
      const products = fashionData.products || [];
      const dresses = products.filter((product) => product.title.toLowerCase().includes('dress'));

      setCardImage(section, 'Boho Dress', dresses[0]);
      setCardImage(section, 'Kimono', findProduct(products, 'kimono'));
      setCardImage(section, 'Jacket', findProduct(products, 'jacket', 'kimono'));
      setCardImage(section, 'Kaftan', findProduct(products, 'kaftan'));
      setCardImage(section, 'Skirt', skirtData.products && skirtData.products[0]);
      setCardImage(section, 'Scarf', scarfData.products && scarfData.products[0]);
      setCardImage(section, 'Slow Fashion', products[0]);
      setCardImage(section, 'Wrap Dress', dresses[1] || dresses[0]);
    } catch (error) {
      return;
    }
  }

  function restoreFashionTab(section) {
    const fashionTab = section.querySelector('.sv-coll-tab[data-tab="fashion"]');
    if (!fashionTab) return;

    fashionTab.removeAttribute('href');
    fashionTab.setAttribute('role', 'button');
    fashionTab.setAttribute('tabindex', '0');
    fashionTab.setAttribute('aria-controls', 'sv-fashion-panel');

    const fashionPanel = section.querySelector('.sv-coll-panel[data-panel="fashion"]');
    if (fashionPanel) fashionPanel.id = 'sv-fashion-panel';

    if (fashionTab.dataset.keyboardReady === 'true') return;
    fashionTab.dataset.keyboardReady = 'true';
    fashionTab.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        fashionTab.click();
      }
    });
  }

  function customizeSkirtCard(section) {
    const titleElement = Array.from(section.querySelectorAll('.sv-card__title')).find(
      (element) => element.textContent.trim() === 'Skirt',
    );
    const card = titleElement && titleElement.closest('.sv-card');

    if (!card) return;

    titleElement.textContent = 'Skirt/Lehengas';

    const description = card.querySelector('.sv-card__desc');
    if (description) {
      description.textContent = 'Statement skirts and lehengas crafted from richly detailed vintage saree textiles';
    }

    const link = card.querySelector('.sv-card__cta');
    if (link) {
      link.textContent = 'Shop Collection';
      link.href = '/search?q=skirt&options%5Bprefix%5D=last';
    }
  }

  function initializeCreativeSection(root) {
    const sections = root.matches && root.matches('.shopify-section')
      ? [root]
      : Array.from(root.querySelectorAll('.shopify-section'));

    sections.forEach((section) => {
      if (!section.querySelector('.sv-coll-panel[data-panel="fashion"]')) return;
      restoreFashionTab(section);
      loadFashionImages(section);
      customizeSkirtCard(section);
    });
  }

  function start() {
    initializeCreativeSection(document);
    document.addEventListener('shopify:section:load', (event) => {
      initializeCreativeSection(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(function () {
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  const styleId = 'sv-shopify-inbox-mobile-close-fix';
  const pageStyleId = 'sv-shopify-inbox-mobile-position-fix';
  const observedRoots = new WeakSet();

  function injectPageFix() {
    if (document.getElementById(pageStyleId)) return;

    const style = document.createElement('style');
    style.id = pageStyleId;
    style.textContent = `
      @media screen and (max-width: 749px) {
        html body #ShopifyChat[is-open="true"] {
          bottom: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function injectCloseFix(root) {
    if (!root || root.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .interstitial-view__welcome [name="closeChat"],
      .chat-header [name="closeChat"] {
        position: absolute !important;
        top: 10px !important;
        right: 10px !important;
        z-index: 10000 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 44px !important;
        height: 44px !important;
        margin: 0 !important;
        padding: 10px !important;
        border-radius: 999px !important;
        background: rgba(0, 0, 0, 0.2) !important;
        pointer-events: auto !important;
      }

      .interstitial-view__welcome [name="closeChat"] svg,
      .chat-header [name="closeChat"] svg {
        width: 24px !important;
        height: 24px !important;
      }
    `;
    root.appendChild(style);
  }

  function installCloseFix() {
    document.querySelectorAll('inbox-online-store-chat').forEach((host) => {
      const root = host.shadowRoot;
      if (!root) return;

      injectCloseFix(root);

      if (!observedRoots.has(root)) {
        observedRoots.add(root);
        new MutationObserver(() => injectCloseFix(root)).observe(root, {
          childList: true,
          subtree: true,
        });
      }
    });
  }

  function start() {
    injectPageFix();
    installCloseFix();
    new MutationObserver(installCloseFix).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
